/* src/app/shared/components/confirmation-dialog/confirmation-dialog.component.scss */
.actions {
  justify-content: center;
}
.red {
  color: red;
}
/*# sourceMappingURL=confirmation-dialog.component.css.map */
